import { loadConfig, renderStudio } from "../../sanity";

export default ({ env }, inject) => {
  inject('sanityStudio', element => {
    const config = loadConfig(env.sanityEnv);
    renderStudio(element, config);
  })
}
